// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RetryPartialError_wrapper__gOsZe","fadein-text":"RetryPartialError_fadein-text__Ipcy4","retry":"RetryPartialError_retry__mP026"};